import { strings } from 'APP_ROOT/localization';

export default class MapboxToggleFollowSelectedRavenControl {

    mapboxControlShouldFollowSelectedRaven;
    mapboxControlCallback;

    constructor(followSelectedRavenByDefault, callbackForButtonEventListener) {
        this.mapboxControlShouldFollowSelectedRaven = followSelectedRavenByDefault;
        this.mapboxControlCallback = callbackForButtonEventListener;
    }

    buttonEventListener = () => {

        this.mapboxControlShouldFollowSelectedRaven = !this.mapboxControlShouldFollowSelectedRaven; // toggle
        this.mapboxControlCallback(this.mapboxControlShouldFollowSelectedRaven);
    }

    onAdd(map) {
        this.map = map;
        this.container = this.container();
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {

        var imageElement = document.createElement('img');
        imageElement.src = '/images/map-btn-center-on-car.png';
        imageElement.style = "width: 30px; padding: 3px;"; /* using padding to shrink the icon down while keeping overall width 30px */

        var buttonElement = document.createElement('button');
        buttonElement.id = 'snapMapToCarBtn';
        buttonElement.title = strings.map_controls_label_toggle_snap_to_vehicle;
        buttonElement.appendChild(imageElement);

        buttonElement.addEventListener('click', this.buttonEventListener);

        var buttonWrapper = document.createElement('div');
        buttonWrapper.appendChild(buttonElement);

        return buttonWrapper;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}